<template>
  <div class="notice-remind">
    <el-carousel :interval="4000" height="400px">
      <el-carousel-item v-for="(item,index) in dataList" :key="index">
        <div class="notice-examine-box">
          <div class="dialog-box__title center">{{item.title}}</div>
          <div class="dialog-box__time center">{{item.updateTime | dayFormat('YYYY-MM-DD HH:mm:ss')}}</div>
          <div class="dialog-box__content" v-html="item.content"></div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'YblNoticeRemind',
  props: {
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.notice-remind {
  .notice-examine-box {
    height: 400px;
    overflow-y: auto;
    img {
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/noticeRemind.vue